import angular from "angular";
import * as _ from "underscore";
import moment from "moment";

interface HeaderData {
    headerLevel: number[] | string[];
    colspan?: number[];
    headerFormatToExport?: string[];
}

interface Column {
    colId: string;
    [key: string]: any;
}

interface IGridValueEditorService {
    prepareHeaderData(startDate: string | Date, endDate: string | Date): HeaderData[];
    parseColId(column: Column): { year: number, month: number };
}

export class GridValueEditorService implements IGridValueEditorService {
    static componentName: string = "gridValueEditorService";
    static $inject = [];

    constructor() {}

    private colspanCounter(years: number[], dateStart: string | Date, dateEnd: string | Date): number[] {
        const currentYearMonth = moment(dateStart).format('M'),
            lastMonth = moment(dateEnd).format('M');
        let colspan: number[] = [];

        for (let i = 0; i < years.length; i++) {
            colspan.push(12)
        }
        colspan[0] = 13 - Number(currentYearMonth);
        colspan[colspan.length - 1] = parseInt(lastMonth);

        return colspan;
    }

    private rangeDateToExportHeader(startDate: string | Date, endDate: string | Date): string[] {
        let start = moment(startDate), dates: string[] = [];
        
        while (start.isSameOrBefore(moment(endDate), 'month')) {
            dates.push(start.format('M/YYYY'));
            start.add(1, 'months');
        }
        return dates;
    }

    prepareHeaderData(startDate: string | Date, endDate: string | Date): HeaderData[] {
        const forecastLength = Math.floor(moment.utc(endDate).diff(moment.utc(startDate), 'months')) + 1;
        let months: string[] = [],
            years = _.range(moment(startDate).get('year'), moment(endDate).get('year') + 1),
            date = moment(startDate);
        
        for (let i = 0, max = forecastLength; i < max; i++) {
            months.push("MONTHS_SHORT." + date.format('M'));
            date = date.add(1, 'months');
        }

        return [
            {
                headerLevel: years,
                colspan: this.colspanCounter(years, startDate, endDate),
                headerFormatToExport: this.rangeDateToExportHeader(startDate, endDate)
            },
            {
                headerLevel: months
            }
        ];
    }

    parseColId(column: Column): { year: number, month: number } {
        const splited = column.colId.split('_');
        return {
            year: parseInt(_.first(splited) || '0'),
            month: parseInt(_.last(splited) || '0')
        };
    }
}

angular
    .module("gridValueEditor")
    .factory(GridValueEditorService.componentName, [() => new GridValueEditorService()]);
